/**
 * Computes the drag bounds for the draggable modal so it can never be dragged outside the viewport. Derives left, right, top and bottom offsets from the wrapper's bounding rect, the current drag delta and the document's client size.
 *
 * @param targetRect - The wrapper's measured bounding rect.
 * @param uiData - Drag position data supplying the current x and y offsets.
 * @param clientWidth - The document element's client width.
 * @param clientHeight - The document element's client height.
 * @returns The left, right, top and bottom bounds to pass to Draggable.
 */
export const computeDragBounds = (
  targetRect: { left: number; right: number; top: number; bottom: number },
  uiData: { x: number; y: number },
  clientWidth: number,
  clientHeight: number,
) => ({
  left: -targetRect.left + uiData.x,
  right: clientWidth - (targetRect.right - uiData.x),
  top: -targetRect.top + uiData.y,
  bottom: clientHeight - (targetRect.bottom - uiData.y),
});
